export const GRAPHQL_VARIABLES = {
  record: {
    title: '',
    birth: '',
    firstName: '',
    ownership: '',
    address: {
      address1: '',
      address2: '',
      address3: '',
      state: '',
      city: '',
      zip: '',
      country: '',
      _id: ''
    },
    email: '',
    mobile: '',
    _id: ''
  }
};

export const QUERY = `
 mutation individualCreateOne ($record: AutoFilledCreateOneindividualsInput!) {
   individualCreateOne (record: $record) {
       recordId
       record {
          title
          birth
          firstName
          lastName
          ownership
          address {
             address1
             address2
             address3
             state
             city
             zip
             country
             _id
          }
          email
          phone
          _id
          documentType
          licenceNumber
          jurisdiction
          country
          roles
          additionalDocumentType
	        driverLicence { url contentType }
          passport { url contentType }
          utilityBill { url contentType }
          ssn
       }
   }
 }
 `;
